<div class="content-area" style="position: relative;">
  <!-- Loading Overlay -->
  <app-loading-overlay [isLoadingAlternatives]="isLoadingAlternatives()"
                       [showInitialLoading]="showInitialLoading()"
                       class="absolute inset-0"
  ></app-loading-overlay>

  <!-- Song Information -->
  <app-song-info [currentSong]="currentSong()"></app-song-info>

  <!-- Description with refresh button -->
  <app-description-panel
      (refreshAlternativePrompt)="handleRequestAlternativePrompt()"
      [currentDescription]="currentDescription()"
      [hasAudioResults]="hasAudioResults()"
      [isLoadingAlternatives]="isLoadingAlternatives()"
  ></app-description-panel>

  <!-- Player Controls Component - handles all audio controls and UI -->
  @if (hasAudioResults() && audioService()) {
    <app-player-controls
        [currentAudioIndex]="audioService()!.currentTrackIndex()"
        [audioResults]="audioResults()"
        [isLoadingAlternatives]="isLoadingAlternatives()"
        (playPrevious)="handlePlayPreviousSong()"
        (playNext)="handlePlayNextSong()"
        (togglePlayPause)="handleTogglePlayPause()"
        (volumeUpdated)="handleVolumeUpdated($event)"
    ></app-player-controls>
  }
</div>
